import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import VueImageLoader from "./components/img-loader";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueIziToast from "vue-izitoast";
import "izitoast/dist/css/iziToast.min.css";

const routes = [];
if (process.env.VUE_APP_BI == "elink") {
  routes.push(
    {
      path: "/",
      component: require("./components/ELink/ELinkOnly").default,
    },
    {
      path: "/book/:isbn",
      component: require("./components/BookRead").default,
    },
    {
      path: "/elink",
      component: require("./components/ELink/ELinkOnly").default,
    },
    {
      path: "/booksearch",
      component: require("./components/BookSearch").default,
    }
  );
} else {
  routes.push(
    { path: "/", component: require("./components/Index/index").default },
    {
      path: "/mag/:brandCode/:issueId",
      component: require("./components/MagPage").default,
    },
    {
      path: "/read/:brandCode/:issueId/:pageNo?",
      component: require("./components/Read").default,
    },
    { path: "/search", component: require("./components/Search").default },
    {
      path: "/elink",
      component: require("./components/ELink/MagzPlus").default,
    },
    {
      path: "/book/:isbn",
      component: require("./components/BookRead").default,
    },
    {
      path: "/booksearch",
      component: require("./components/BookSearch").default,
    }
  );
}

const router = new VueRouter({
  mode: "history",
  routes,
});

Vue.use(VueRouter);
Vue.use(VueImageLoader);
Vue.component("loading", Loading);
Vue.use(VueIziToast);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
